import Vue from 'vue'
import Methods from '../lib/methods';
Vue.mixin({
    data() {
        return {
            dates: {
                year: '',
                day: '',
                week: '',
            },
            Page: 1,
            Filter: {
                key: null,
            },
            // Params: {},
            Editer: {
                name: "",
                show: false,
                title: "",
                params: "",
                width: "30%"
            },
            pagelist: [10, 20, 30, 50, 100],
            pickerStartDate: {
                disabledDate: (time) => {
                    let beginDateVal = this.formInline.end_date, start = new Date(time)
                    if (beginDateVal) {
                        let end = new Date(beginDateVal);
                        return start.getTime() > end.getTime();
                    }
                    return start.getTime() > new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
                }
            },
            pickerEndDate: {
                disabledDate: (time) => {
                    let beginDateVal = this.formInline.start_date, end = new Date(time);
                    if (beginDateVal) {
                        let start = new Date(beginDateVal);
                        return end.getTime() < start.getTime() - 24 * 60 * 60 * 1000 || end.getTime() > Date.now();
                    }
                    return end.getTime() > new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
                }
            },
            Aweek: {
                disabledDate(time) {
                    return time.getTime() > new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1);
                },
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            taday: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            pickerOptions2: {
                disabledDate(time) {
                    return time.getTime() > new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1);

                },
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近十天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 10);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近半个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
        }
    },
    computed: {
        User() {
            return this.$store.state.user.baseInfo || {}
        },
    },
    methods: {
        // 分页组件
        handleSizeChange(val) {
            this.formInline.limit = val
            this.getlist()
        },
        // 分页组件
        handleCurrentChange(val) {
            this.formInline.page = val
            this.getlist()
        },
        // 控制弹窗
        modalView(modal) {
            this.Editer.show = false;
            this.$nextTick(() => {
                this.Editer = {
                    show: true,
                    ...modal
                };
            });
        },
        // 关闭弹窗
        exit() {
            this.Editer.show = false;
        },
        // 游戏类型
        gameType(val) {
            let type = this.gamelist.find(item => {
                return item.value == val;
            });
            return type ? type.label : val;
        },
        //游戏大类型
        gamebigTypes(val) {
            let type = this.playbigTypes.find(item => {
                return item.value == val;
            });
            return type ? type.label : val;
        },
        callBack() {
        },
        //关闭弹窗 重置表单
        handleClose() {
            // if (this.$refs.mychild.resetForm)
            //     this.$refs.mychild.resetForm();
        },
        //权限校验
        hasPermission(permission) {
            let perBtns = store.state.user.baseInfo.authority.split(",");
            return perBtns.indexOf(permission.toString()) > -1
        },
        ...Methods,
    },
})


// WEBPACK FOOTER //
// ./src/lib/mixin.js